import type { CreateChatThread200AllOfCurrentUserStatus } from './createChatThread200AllOfCurrentUserStatus';
import type { CreateChatThread200AllOfParticipantsItem } from './createChatThread200AllOfParticipantsItem';

export type CreateChatThread200AllOf = {
  chatRoomId: number;
  createdAt: string;
  currentUserStatus?: CreateChatThread200AllOfCurrentUserStatus;
  isGroupThread: boolean;
  /** @nullable */
  lastMessage?: string | null;
  /** @nullable */
  lastMessageTime?: string | null;
  participants: CreateChatThread200AllOfParticipantsItem[];
  /** @nullable */
  unreadMessageCount?: number | null;
};
